import {Component, OnInit} from "@angular/core";
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

export const EMRIntegrationHyperdriveInitiateHandshakeAction = "Epic.Clinical.Informatics.Web.InitiateHandshake";
export const EMRIntegrationHyperdriveOpenExternalWindowAction = "Epic.Clinical.Informatics.Web.OpenExternalWindow";
export const EMRIntegrationHyperdriveOpenDefaultBrowser = "Epic.Common.OpenDefaultBrowser";
export const EMRIntegrationHyperdriveSelectProtocolFromPathwaysAction = "Epic.Clinical.Oncology.SelectProtocolFromPathways";

@Component({
  selector: 'gen-iframe-test-component',
  templateUrl: './iframe-test-component.html',
  styleUrls: ['./iframe-test.component.css']
})

export class IframeTestComponent implements OnInit {
  public iframeSrc: SafeResourceUrl;
  public iframeSrcTxt: string;
  private responseMockMap = "responseMockMap";
  private webMessagesMockMap: object;
  private postMessage: object;
  private mockMapActions = {
    "InitiateHandshake": EMRIntegrationHyperdriveInitiateHandshakeAction,
    "OpenExternalWindow": EMRIntegrationHyperdriveOpenExternalWindowAction,
    "OpenDefaultBrowser": EMRIntegrationHyperdriveOpenDefaultBrowser,
    "SelectProtocolFromPathways": EMRIntegrationHyperdriveSelectProtocolFromPathwaysAction,
  }

  constructor(private sanitizer: DomSanitizer,
              private routerManagerService: RouterManagerService) {
  }

  ngOnInit(): void {
    try {
      this.iframeSrcTxt = this.routerManagerService.queryParameters.src;
      if (this.iframeSrcTxt)
        this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.iframeSrcTxt);

      const responseMock = this.routerManagerService.queryParameters.responseMockMap;
      if (responseMock)
        this.webMessagesMockMap = JSON.parse(responseMock);
    } catch (err) {
      console.log("### Iframe launch bad request => ", err);
    }

    window.addEventListener('message', this.parentWebMessagesListener.bind(this), false);
  }

  parentWebMessagesListener(event) {
    this.postMessage = null;
    const iframeWindow = (document.getElementById("iframe-id") as HTMLIFrameElement);
    if (event.data.action == EMRIntegrationHyperdriveInitiateHandshakeAction ||
      event.data.action == EMRIntegrationHyperdriveOpenExternalWindowAction ||
      event.data.action == EMRIntegrationHyperdriveOpenDefaultBrowser ||
      event.data.action == EMRIntegrationHyperdriveSelectProtocolFromPathwaysAction) { //web message action

      if (!!this.webMessagesMockMap) {
        for (let messageName in this.webMessagesMockMap) {
          if (!!this.webMessagesMockMap[messageName]) {
            if (event.data.action == this.mockMapActions[messageName]) {
              this.postMessage = this.getMessageByMockMap(messageName);
            }
          }
        }
      } else {
        if (event.data.action == EMRIntegrationHyperdriveInitiateHandshakeAction) {
          this.postMessage = {
            "actions":
              [
                "Epic.Clinical.Informatics.Web.InitiateHandshake",
                "Epic.Clinical.Informatics.Web.OpenExternalWindow",
                "Epic.Common.OpenDefaultBrowser",
                "Epic.Clinical.Oncology.SelectProtocolFromPathways"
              ],
            "token": "ad7113eb-0389-4a72-a5f2-61e7105049a4",
            "actionExecuted": true,
            "errorCodes": []
          };
        } else {
          this.postMessage = {
            "actionExecuted": true,
            "errorCodes": []
          };
        }
      }
      if (this.postMessage == null){
        this.postMessage = {
          "actionExecuted": true,
          "errorCodes": []
        };
      }
      try {
        iframeWindow.contentWindow.postMessage(this.postMessage, "*");
        console.log("Send mock response: ", this.postMessage);
      } catch (e) {
        iframeWindow.contentWindow.postMessage({"error": +e}, "*");
        console.log("Got error for: ", this.postMessage, e);
      }
    }
  }

  getMessageByMockMap(messageName: string): object {
    let message = {};
    let value = "";
    if (this.webMessagesMockMap[messageName]["token"]) {
      value = this.webMessagesMockMap[messageName]["token"];
      message = {
        "actions":
          [
            "Epic.Clinical.Informatics.Web.InitiateHandshake",
            "Epic.Clinical.Informatics.Web.OpenExternalWindow",
            "Epic.Common.OpenDefaultBrowser",
            "Epic.Clinical.Oncology.SelectProtocolFromPathways"
          ],
        "token": value,
        "actionExecuted": true,
        "errorCodes": []
      }
    }
    if (this.webMessagesMockMap[messageName]["errorCodes"]) {
      value = this.webMessagesMockMap[messageName]["errorCodes"];
      message = {
        "error": this.webMessagesMockMap[messageName]["error"] ? this.webMessagesMockMap[messageName]["error"] : "test error code message",
        "actionExecuted": false,
        "errorCodes": value
      }
    }
    return message;
  }

  ngDestroy(): void {
    window.removeEventListener("message", this.parentWebMessagesListener);
  }
}
